import { ArrowRightIcon } from '@heroicons/react/16/solid';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useUploadBusyStore } from '../../store/use-upload-busy-store';

export function NextButton({ label }) {
  const { t } = useTranslation();
  const { isValid, isSubmitting } = useFormState();
  const isBusy = useUploadBusyStore((s) => s.count > 0);

  return (
    <button
      type="submit"
      form="patch-invite-form"
      className="pl-5 flex-grow flex items-center justify-between gap-4 font-medium text-white bg-primary hover:text-white hover:bg-primary-hover active:bg-primary-active disabled:opacity-60 disabled:pointer-events-none transition-all"
      disabled={!isValid || isSubmitting || isBusy}
    >
      <div>{isSubmitting ? t('loading') : label}</div>
      <div className="size-12.5 flex items-center justify-center" aria-hidden="true">
        <ArrowRightIcon className="size-6" />
      </div>
    </button>
  );
}
